<template>
    <div class="basket-item d-flex flex-column flex-lg-row align-items-start justify-content-lg-between">
        <div class="basket-item-top d-flex">
            <figure class="basket-item-figure align-self-start">
                <img
                    v-if="item.image_url"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    :data-src="responsiveImagesLast"
                    :data-srcset="responsiveImages"
                    data-sizes="auto"
                    class="image-responsive lazyload lazyload-animate"
                    :alt="item.title"
                >
            </figure>
            <div class="basket-item-content d-flex flex-column">
                <p class="basket-item-title">{{ item.title }}</p>
                <p v-for="variant_meta in item.variant_metas">
                    {{ variant_meta.title }} - {{ variant_meta.value }} <br/>
                </p>

                <button
                    @click="removeItem"
                    class="basket-item-remove btn-link text-left"
                >
                    {{ $t('basket.remove') }}
                </button>
            </div>
        </div>

        <div class="basket-item-bottom d-flex justify-content-between">
            <input-toggle
                @updateValue="updateBasketItem"
                :min-value="item.minimal_order_quantity ? item.minimal_order_quantity : 0"
                :multiply="item.multiply ? item.multiply : 1"
                :value="item.quantity"
            />

            <div class="price price-large d-flex flex-column-reverse align-items-end">
                <span
                    v-if="item.price.old"
                    class="price-old"
                >
                    <span v-if="isBusinessUser">
                        {{ item.priceExcTotal.old | currency }}
                    </span>
                    <span v-else>
                        {{ item.priceTotal.old | currency }}
                    </span>
                </span>

                <span v-if="isBusinessUser">
                    {{ item.priceExcTotal.amount | currency }}
                </span>
                <span v-else>
                    {{ item.priceTotal.amount | currency }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import axios from 'axios';
    import cdn from '@23g/cdn-helper';
    import InputToggle from '@/_vue/components/ui/input-toggle';

    export default {
        name: 'BasketItem',
        components: {
            InputToggle,
        },
        props: {
            item: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                imageWidths: [
                    'h360',
                    'h720',
                ],
            };
        },
        computed: {
            responsiveImagesLast() {
                return cdn(this.item.image_url, 'h720');
            },

            responsiveImages() {
                return this.generateImageSizes(this.item.image_url, this.imageWidths);
            },
        },
        methods: {
            ...mapActions('basket', [
                'fetchBasket',
            ]),

            async updateBasketItem(quantity) {
                await axios.post(this.route('cart.product.update'), {
                    variant_id: this.item.id,
                    quantity,
                });

                if (quantity === 0) this.removeItem();
                else this.fetchBasket();
            },

            async removeItem() {
                await axios.post(this.route('cart.product.remove'), {
                    variant_id: this.item.id,
                });

                this.fetchBasket();
            },
        },
    };
</script>
